import React, { Component } from "react";
import { connect } from "react-redux";
import CustomSelect from "../../components/common/select/Select";
import ProductMiddleware from "../../store/prat_middleware/gt/productMiddleware";
import ActivityNetworkMiddleware from "../../store/prat_middleware/activitynetwork/activityNetworkMiddleware";
import DATA from "../../assets/data";
import {compare} from '../gt/validation/sort';

class ActivityNetwork extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedProductCategories: [],
      selectedProductMasterSkus: [],
      selectedProductBrands: [],
      myBrands: [],
      myMasterSkus: [],
      selectedYear: new Date().getFullYear(),
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.props.get_productCategories();
      this.props.get_productBrands();
      this.props.get_productMasterSkus();
    }, 1000);
  }

  handleCategory = (category) => {
    let arr = [];
    if (category === null || category.length === 0) {
      this.setState({
        selectedProductCategories: [],
        selectedProductBrands: [],
        selectedProductMasterSkus: [],
        selectedProductSkus: [],
        myBrands: [],
        myMasterSkus: [],
        selectedProductFormats: [],
      });
    } else {
      category.forEach((element) => {
        arr.push(element.value);
      });
      this.setState({ selectedProductCategories: arr }, () => {
        this.handleFilteredBrands();
      });
    }
  };

  handleFilteredBrands = () => {
    const {
      selectedProductCategories,
      myBrands,
      selectedProductBrands,
    } = this.state;
    const { product_brands } = this.props;
    let filteredbrands = [];
    if (selectedProductCategories.length) {
      for (let i = 0; i < selectedProductCategories.length; i++) {
        filteredbrands.push(
          ...product_brands.filter((item) => {
            return item.Category === selectedProductCategories[i];
          })
        );
      }
      this.setState({
        myBrands: filteredbrands,
      });
      let arr = [];
      if (selectedProductBrands.length !== 0) {
        myBrands.forEach((element) => {
          selectedProductBrands.forEach((e, i) => {
            if (element.guid === e) {
              arr.push(e);
              this.setState({ selectedProductBrands: arr });
            } else {
            }
          });
        });
      }
    }
  };

  handleBrandChange = (selectedBrand) => {
    let arr = [];
    if (selectedBrand === null || selectedBrand.length === 0) {
      this.setState({
        selectedProductBrands: [],
        selectedProductMasterSkus: [],
        selectedProductSkus: [],
        myMasterSkus: [],
        selectedProductFormats: [],
      });
    } else {
      selectedBrand.forEach((e) => {
        arr.push(e.value);
      });
      this.setState({ selectedProductBrands: arr }, () => {
        this.handleFilteredMasterSku();
      });
    }
  };

  handleFilteredMasterSku = () => {
    const {
      selectedProductBrands,
      selectedProductMasterSkus,
      myMasterSkus,
    } = this.state;
    const { product_master_skus } = this.props;
    let filteredSkus = [];
    if (selectedProductBrands.length) {
      for (let i = 0; i < selectedProductBrands.length; i++) {
        filteredSkus.push(
          ...product_master_skus.filter((item) => {
            return item.Brand === selectedProductBrands[i];
          })
        );
      }
      this.setState({
        myMasterSkus: filteredSkus,
      });
      let selectedSkuFinal = [];
      if (selectedProductMasterSkus.length !== 0) {
        myMasterSkus.forEach((element) => {
          selectedProductMasterSkus.forEach((e, i) => {
            if (element.guid === e) {
              selectedSkuFinal.push(e);
              this.setState({ selectedProductMasterSkus: selectedSkuFinal });
            } else {
            }
          });
        });
      }
    }
  };

  handleMasterSkusChange = (selectedMasterSku) => {
    let arr = [];
    if (selectedMasterSku === null || selectedMasterSku.length === 0) {
      this.setState({
        selectedProductMasterSkus: [],
        selectedProductSkus: [],
        selectedProductFormats: [],
      });
    } else {
      selectedMasterSku.forEach((e) => {
        arr.push(e.value);
      });
      this.setState({ selectedProductMasterSkus: arr });
    }
  };

  handleYearChange = (selectedValue) => {
    if (selectedValue) {
      this.setState({
        selectedYear: selectedValue.value,
      });
    } else {
      this.setState({
        selectedYear: "",
      });
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
  };

  handleDownloadXlsxFile = () => {
    this.props.download_activityNetwork(
        this.state.selectedProductCategories,
        this.state.selectedProductBrands,
        this.state.selectedProductMasterSkus,
        this.state.selectedYear,
    )
  };

  render() {
    return (
        <div className="page-container">

        <div className="heading-and-download-container">

            <span className='component-heading'>Activity Network</span>

            {this.props.isFileDownloading ? (
                <img alt='' style={{ width: '26px', height: '31px' }} src={require('../../assets/gifs/Downloading.gif')} />
            ) : (
                <img alt='' style={{ cursor: 'pointer' }} src={require('../../assets/images/downloadIcon.svg')} onClick={this.handleDownloadXlsxFile} />
                )}
        </div>

        <div className='select-download-container'>

            <div className="select-container">
                <div className='filters-container-only'>
                    <CustomSelect.MyCustomSelect
                        placeholder={"Category"}
                        allowSelectAll={true}
                        isMulti
                        options={
                            this.props.product_categories
                                ? !this.props.product_categories
                                    ? void 0
                                    : this.props.product_categories.sort(compare).map(item => ({
                                        value: item.guid,
                                        label: item.Name
                                    }))
                                : []
                        }
                        onChange={this.handleCategory}
                        value={
                            this.props.product_categories
                                ? this.props.product_categories
                                    .filter(item => {
                                        return !this.state.selectedProductCategories
                                            ? void 0
                                            : this.state.selectedProductCategories.includes(item.guid);
                                    })
                                    .map(item => {
                                        return {
                                            value: item.guid,
                                            label: item.Name
                                        };
                                    }) : void 0
                        }
                    />

                    <CustomSelect.MyCustomSelect
                        placeholder={"Brand"}
                        allowSelectAll={true}
                        isMulti
                        options={
                            this.state.myBrands
                                ? this.state.myBrands.sort(compare).map(item => ({
                                    value: item.guid,
                                    label: item.Name
                                }))
                                : void 0
                        }
                        onChange={this.handleBrandChange}
                        value={
                            this.state.myBrands
                                ? this.state.myBrands
                                    .filter(item => {
                                        return this.state.selectedProductBrands.includes(item.guid);
                                    })
                                    .map(item => {
                                        return {
                                            value: item.guid,
                                            label: item.Name
                                        };
                                    })
                                : null
                        }
                    />

                    <CustomSelect.MyCustomSelect
                        placeholder={"Master SKU"}
                        allowSelectAll={true}
                        isMulti
                        options={
                            this.state.myMasterSkus
                                ? this.state.myMasterSkus.sort(compare).map(item => ({
                                    value: item.guid,
                                    label: item.Description
                                }))
                                : void 0

                        }
                        onChange={this.handleMasterSkusChange}
                        value={
                            this.state.myMasterSkus
                                ? this.state.myMasterSkus
                                    .filter(item => {
                                        return this.state.selectedProductMasterSkus.includes(item.guid);
                                    })
                                    .map(item => {
                                        return {
                                            value: item.guid,
                                            label: item.Description
                                        };
                                    })
                                : null
                        }
                    />

                    <CustomSelect.MyCustomSelect
                        className="select-box"
                        placeholder={"Year"}
                        isClearable={true}
                        options={DATA.YEARSPreVsPostOpso.map((item) => ({
                            value: item.value,
                            label: item.label,
                        }))}
                        onChange={this.handleYearChange}
                        value={DATA.YEARSPreVsPostOpso
                            ? DATA.YEARSPreVsPostOpso
                                .filter(item => {       // eslint-disable-line
                                    if (item.value === this.state.selectedYear) {
                                        return item
                                    }
                                })
                                .map(item => {
                                    return {
                                        value: item.value,
                                        label: item.label
                                    };
                                }) : void 0}
                    />

                </div>

            </div>

        </div>

    </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    product_categories: state.ProductReducer.productCategories,
    product_brands: state.ProductReducer.productBrands,
    product_master_skus: state.ProductReducer.productMasterSkus,
    isFileDownloading: state.DownloadXlxReducer.isFileDownloading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    get_productCategories: () => {
      return dispatch(ProductMiddleware.get_categories());
    },
    get_productBrands: () => {
      return dispatch(ProductMiddleware.get_brands());
    },
    get_productMasterSkus: () => {
      return dispatch(ProductMiddleware.get_master_skus());
    },
    download_activityNetwork: (
      selectedProductCategories,
      selectedProductBrands,
      selectedProductMasterSkus,
      selectedYear
    ) => {
      return dispatch(
        ActivityNetworkMiddleware.download_activityNetwork(
          selectedProductCategories,
          selectedProductBrands,
          selectedProductMasterSkus,
          selectedYear
        )
      );
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ActivityNetwork);
